import classNames from 'classnames'

const SmallButton = ({children, onClick, className}) => {
    return (
        <button
            className={classNames('small-button', {
                [className]: !!className
            })}
            onClick={onClick}>
            {children}
        </button>
    )
}

export default SmallButton
